module.exports.PRODUCT_NAME =
  typeof __KB_PRODUCT_NAME !== 'undefined' ? __KB_PRODUCT_NAME : undefined
module.exports.PRODUCT_INFO =
  typeof __KB_PRODUCT_INFO !== 'undefined' ? __KB_PRODUCT_INFO : undefined

module.exports.PRODUCT_INFO_MAP = {
  name: 'name',
  'name-possess': 'namePossessive',
  'email-support': 'emailSupport',
  'email-sales': 'emailSales',
  website: 'website',
  'app-website': 'appWebsite',
  phone: 'phone',
}
